import '../../fonts/Gotham/fontface.css';

const colors = {
  black: 'rgb(0, 0, 0)',
  white: 'rgb(255, 255, 255)',
  white50: 'rgba(255, 255, 255, 0.5)',
  gray: 'rgb(204, 204, 204)',
  lighterGray: 'rgb(244, 245, 246)',
  lightGray: 'rgb(230, 230, 230)',
  mediumGray: 'rgb(155, 155, 155)',
  mediumGray2: 'rgb(129, 129, 129)',
  darkGray: 'rgb(51, 51, 51)',
  blue: 'rgb(70, 152, 202)',
  lightBlue: 'rgb(209, 231, 236)',
  darkBlue: 'rgb(113, 134, 140)',
  green: 'rgb(116, 165, 74)',
  lightGreen: 'rgb(232, 236, 226)',
  darkGreen: 'rgb(136,144,129)',
  darkPurple: 'rgb(66,44,64)',
  lightPurple: 'rgb(180, 156, 185)',
  red: 'rgb(200, 49, 69)',
  lighterRed: ' rgb(222, 194, 194)',
  darkRed: ' rgb(95, 39, 39)',
  darkBrown: 'rgb(95,66,64)',
  darkerBrown: 'rgb(71, 64, 64)',
  lightBrown: 'rgb(229,222,217)',
  lightYellow: 'rgb(255, 246, 233)',

  brightOrange: '#e68532',
  brightBlue: '#3b91a4',
  brightYellow: '#ffd700',
  brightGreen: '#7b9f34',
  brightBrown: '#86482c',
};

const breakPoints = {
  xs: 0,
  sm: 600,
  md: 840,
  lg: 1280,
  xl: 1920,
};

const brandColors = {
  primaryDark: '#1e1f20',
  primaryLight: '#fffef8',
};

const textColors = {
  bodyText: brandColors.primaryDark,
  mutedText: '#7D7D7D',
  disabledText: '#B9B9B9',
  lightText: colors.white,
};
const textFontFamilies = {
  fontTypography: 'Lato, sans-serif',
  fontBody1: 'Lato, sans-serif',
  fontBody2: 'Lato, sans-serif',
  fontHeadings: 'Laca, sans-serif',
  fontBotton: 'Lato, sans-serif',
};

const textFontSizesMobile = {
  fontSizeLeadText: '1.125rem',
  fontSizeTypography: '0.938rem',
  fontSizeButton: '0.875rem',
  fontSizeBody1: '0.938rem',
  fontSizeBody2: '0.813rem',
  fontSizeH1: '2.75rem',
  fontSizeH2: '2rem',
  fontSizeH3: '1.375rem',
  fontSizeH4: '1.125rem',
};
const textFontSizesDesktop = {
  fontSizeLeadText: '1.188rem',
  fontSizeTypography: '1rem',
  fontSizeButton: '1rem',
  fontSizeBody1: '1rem',
  fontSizeBody2: '0.813rem',
  fontSizeH1: '4rem',
  fontSizeH2: '3rem',
  fontSizeH3: '1.625rem',
  fontSizeH4: '1.125rem',
};
const textFontWeight = {
  typography: 'normal',
  button: '600',
  body1: 'normal',
  body2: 'normal',
  h1: '600',
  h2: '600',
  h3: '600',
  h4: '600',
};
const textLineHeightsMobile = {
  lineHeightLeadText: '1.5',
  lineHeightQuote: '1.47',
  lineHeightBody1: '1.47',
  lineHeightBody2: '1.54',
  lineHeightHeadings: 'normal',
};

const textLineHeightsDesktop = {
  lineHeightLeadText: '1.58',
  lineHeightQuote: '1.5',
  lineHeightBody1: '1.5',
  lineHeightBody2: '1.54',
  lineHeightHeadings: 'normal',
};

const typography = {
  h1: {
    marginBottom: '2.5rem',
  },
  h2: {
    marginBottom: '1.75rem',
    textTransform: 'none',
  },
  h3: {
    marginBottom: '1rem',
  },
  h4: {
    marginBottom: '1rem',
  },
  h5: {
    marginBottom: '1rem',
  },
  h6: {
    marginBottom: '1rem',
  },
};

const textMargins = {
  textMarginBottomH1: '2.5rem',
};

const pageTemplates = {
  landingPage: {
    mobile: {
      paddingTop: 0, // => value x 8px
    },
    desktop: {
      paddingTop: 0, // => value x 8px
    },
  },
  otherPageTemplates: {
    mobile: {
      paddingTop: 0, // => value x 8px
    },
    desktop: {
      paddingTop: 0, // => value x 8px
    },
  },
};

const linkColors = {
  link: '#4a3724',
  linkHover: '#644629',
  linkPressed: '#644629',
};

const iconColors = {
  iconColor: '#333333',
};
const hr = {
  height: '2px',
  color: '#9898a0',
  backgroundColor: '#9898a0',
};

const backgroundColors = {
  paper: '#fffef8',
  grayLight: '#f0f0f0',
  grayDark: '#373737',
  goldLight: '#F1E8E2',
  overlay: 'rgba(51,51,51,0.5)',
};

const formColors = {
  inputBorder: '#9898a0',
  inputBackground: '#F0F0F0',
  inputActiveBorder: '#210101',
  inputBorderRadius: '12px', // should be added to gammeldansk brank
};

const primaryButtonColors = {
  primaryButtonBackground: brandColors.primaryDark,
  primaryButtonHoveredBackground: '#0e0e0f',
  primaryButtonPressedBackground: '#0e0e0f',
  primaryButtonDisabledBackground: '#9898a0',
  primaryButtonContents: '#FFFFFF',
};

const secondaryButtonColors = {
  secondaryButtonBackground: brandColors.primaryDark,
  secondaryButtonHoveredBackground: '#0e0e0f',
  secondaryButtonPressedBackground: '#0e0e0f',
  secondaryButtonDisabledBackground: '#9898a0',
  secondaryButtonContents: '#FFFFFF',
};

const outlinedButtonColors = {
  outlinedButton: brandColors.primaryDark,
  outlinedButtonHovered: '#0e0e0f',
  outlinedButtonPressed: '#0e0e0f',
  outlinedButtonDisabled: '#9898a0',
  outlinedButtonHoveredBackground: brandColors.primaryDark,
};

const buttonSettings = {
  buttonPaddingDesktop: '12px 24px',
  buttonPaddingMobile: '8px 16px',
  borderRadius: '0',
  textTransform: 'inherit',
};

const notificationColors = {
  infoBackground: '#E7EEF8',
  successBackground: '#E9F8EA',
  warningBackground: '#FDF2E9',
  errorBackground: '#F6E6E6',

  infoContents: '#3D68A8',
  successContents: '#218E2C',
  warningContents: '#E8770E',
  errorContents: '#D71717',
};

const header = {
  text: brandColors.primaryDark,
  background: colors.white,
  border: {
    style: 'none',
    bottomWidth: '0',
  },
  minHeight: '72px',
  paddingYDesktop: '60px',
  navigation: {
    activeLink: linkColors.linkPressed,
    activeLinkBorder: 'none',
    hoverText: linkColors.linkHover,
    subMenuBackground: colors.white,
    subMenuBulletPoints: colors.white,
  },
  icons: {
    color: colors.white,
    backgroundColor: colors.black,
  },
};

const footer = {
  border: {
    color: 'transparent',
    width: '3px',
  },
  divider: brandColors.primaryLight,
  text: '#f0f0f0',
  background: brandColors.primaryDark,
  logoBarBackground: brandColors.primaryDark,
  padding: {
    bottom: '50px',
  },
};

const accordion = {
  backgroundColor: backgroundColors.grayLight,
  borderRadius: '12px',
  color: linkColors.link,
  flexDirection: 'row',
  hover: {
    backgroundColor: brandColors.primaryLight,
    color: linkColors.hover,
  },
  expandIcon: {
    backgroundColor: 'inherit',
    hover: {
      backgroundColor: 'inherit',
    },
  },
  padding: {
    left: '12px',
    right: '8px',
  },
};

const languageSelector = {
  border: {
    color: formColors.inputBorder,
    width: '2px',
  },
  margin: '0',
};

const table = {
  border: `solid 1px ${brandColors.primaryDark}`,
  borderRadius: '4px',
  head: {
    backgroundColor: brandColors.primaryDark,
    color: colors.white,
  },
  row: {
    even: {
      backgroundColor: colors.white,
    },
  },
  cell: {
    border: `solid 1px ${brandColors.primaryDark}`,
  },
};

const category = {
  outlined: {
    background: backgroundColors.grayLight,
    text: linkColors.link,
  },
  text: linkColors.link,
  hoverText: linkColors.linkHover,
};

const mobileNavigation = {
  text: colors.darkerBrown,
  icon: textColors.bodyText,
  xIconBackground: colors.lightBrown,
  logoBarBottomBorder: colors.darkBlue,
  navigationElementBorder: colors.lightGray,
  subNavigationTitleBackground: brandColors.primaryLight,
  subNavigationTitleColor: colors.white,
  drawer: {
    paper: {
      backgroundColors: backgroundColors.paper,
      widthDesktop: '350px',
    },
  },
};

export const wennercoPrimaryTheme = {
  colors,
  breakPoints,
  brandColors,
  textColors,
  textFontFamilies,
  textFontSizesMobile,
  textFontSizesDesktop,
  textFontWeight,
  textLineHeightsMobile,
  textLineHeightsDesktop,
  textMargins,
  pageTemplates,
  linkColors,
  iconColors,
  backgroundColors,
  formColors,
  primaryButtonColors,
  secondaryButtonColors,
  outlinedButtonColors,
  buttonSettings,
  notificationColors,
  header,
  footer,
  accordion,
  table,
  category,
  mobileNavigation,
  hr,
  typography,
  languageSelector,
};
